import React from "react";
import { EntityDescriptor, FieldDescriptor } from "../entity_crud/EntityDescriptor";
import { BackgroundTaskEditorPage, sliceBackgroundTaskEditorPage } from "./BackgroundTaskEditorPage";
import GeneratedFilesFieldRenderer from "./GeneratedFilesFieldRenderer";
import ParamJsonFieldRenderer from "./ParamJsonFieldRenderer";

export enum BackgroundTaskStatus {
  FAILED = "FAILED",
  FINISHED = "FINISHED",
  PENDING = "PENDING",
  RUNNING = "RUNNING",
}

export interface BackgroundTask {
  id?: number;
  createdAt?: Date;
  startedAt?: Date;
  finishedAt?: Date;
  status?: BackgroundTaskStatus;
  reportIdAndSubId?: string;
  bean?: string;
  method?: string;
  paramJson?: string;
  generatedFiles?: string;
  error?: string;
}

export class BackgroundTaskEntityDescriptor extends EntityDescriptor {
    
    constructor() {
        super({
            name: "BackgroundTask",
            icon: "tasks",
            miniFields: ["bean", "method"],
        });
        this.isInDefaultColumnConfig(true, "id", "reportIdAndSubId", "status", "createdAt", "startedAt", "finishedAt", "generatedFiles", "user", "organization")
            
        this.addFieldDescriptor(
            { name: "generatedFiles" },
            new class extends FieldDescriptor {
                protected renderFieldInternal(RendererClass: any, props: any, entity: any) {
                    return React.createElement(GeneratedFilesFieldRenderer, props);
                }
            }()
        );
        this.addFieldDescriptor(
            { name: "paramJson" },
            new class extends FieldDescriptor {
                protected renderFieldInternal(RendererClass: any, props: any, entity: any) {
                    return React.createElement(ParamJsonFieldRenderer, props);
                }
            }()
        );
    }

    protected customize() {
        this.infoEditor.slice = sliceBackgroundTaskEditorPage.setEntityDescriptor(this);
        this.infoEditor.wrappedComponentClass = BackgroundTaskEditorPage;
    }
}
